import { render, staticRenderFns } from "./RagioneriaContabilitaInviaView.vue?vue&type=template&id=1070a496&"
import script from "./RagioneriaContabilitaInviaView.vue?vue&type=script&lang=ts&"
export * from "./RagioneriaContabilitaInviaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports